export enum LoopMode {
	NO_LOOP,
	LOOP_VIDEO,
	LOOP_PLAYLIST,
}